/* tslint:disable */
/* eslint-disable */
/**
 * ETL API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EtlJob } from '../model';
// @ts-ignore
import { EtlJobStatus } from '../model';
// @ts-ignore
import { EtlJobWithError } from '../model';
// @ts-ignore
import { OrganizationAnalyticsEtlService } from '../model';
/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the details of a specific ETL job.
         * @summary Get ETL job details
         * @param {number} job The ETL job key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtlJob: async (job: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'job' is not null or undefined
            assertParamExists('getEtlJob', 'job', job)
            const localVarPath = `/analytics/etl/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (job !== undefined) {
                localVarQueryParameter['job'] = job;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of all ETL jobs.
         * @summary Get all ETL jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtlJobs: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/etl/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the organization\'s ETL service type.
         * @summary Get ETL service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtlService: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/etl/service`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the status of a specific ETL job.
         * @summary Get ETL job status
         * @param {number} job The ETL job key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtlStatus: async (job: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'job' is not null or undefined
            assertParamExists('getEtlStatus', 'job', job)
            const localVarPath = `/analytics/etl/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (job !== undefined) {
                localVarQueryParameter['job'] = job;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the statuses of multiple ETL jobs.
         * @summary Set ETL job statuses
         * @param {{ [key: string]: EtlJobStatus; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEtlStatus: async (requestBody: { [key: string]: EtlJobStatus; }, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('setEtlStatus', 'requestBody', requestBody)
            const localVarPath = `/admin/analytics/etl/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates analytics jobs and returns details along with any errors.
         * @summary Start analytics jobs
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAnalyticsJobs: async (requestBody: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('startAnalyticsJobs', 'requestBody', requestBody)
            const localVarPath = `/analytics/etl/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the details of a specific ETL job.
         * @summary Get ETL job details
         * @param {number} job The ETL job key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEtlJob(job: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EtlJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEtlJob(job, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a list of all ETL jobs.
         * @summary Get all ETL jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEtlJobs(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EtlJob>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEtlJobs(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the organization\'s ETL service type.
         * @summary Get ETL service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEtlService(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationAnalyticsEtlService>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEtlService(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the status of a specific ETL job.
         * @summary Get ETL job status
         * @param {number} job The ETL job key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEtlStatus(job: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EtlJobStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEtlStatus(job, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the statuses of multiple ETL jobs.
         * @summary Set ETL job statuses
         * @param {{ [key: string]: EtlJobStatus; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setEtlStatus(requestBody: { [key: string]: EtlJobStatus; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EtlJob>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setEtlStatus(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Initiates analytics jobs and returns details along with any errors.
         * @summary Start analytics jobs
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startAnalyticsJobs(requestBody: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EtlJobWithError>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startAnalyticsJobs(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Retrieves the details of a specific ETL job.
         * @summary Get ETL job details
         * @param {number} job The ETL job key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtlJob(job: number, options?: any): AxiosPromise<EtlJob> {
            return localVarFp.getEtlJob(job, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of all ETL jobs.
         * @summary Get all ETL jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtlJobs(options?: any): AxiosPromise<Array<EtlJob>> {
            return localVarFp.getEtlJobs(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the organization\'s ETL service type.
         * @summary Get ETL service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtlService(options?: any): AxiosPromise<OrganizationAnalyticsEtlService> {
            return localVarFp.getEtlService(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the status of a specific ETL job.
         * @summary Get ETL job status
         * @param {number} job The ETL job key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtlStatus(job: number, options?: any): AxiosPromise<EtlJobStatus> {
            return localVarFp.getEtlStatus(job, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the statuses of multiple ETL jobs.
         * @summary Set ETL job statuses
         * @param {{ [key: string]: EtlJobStatus; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEtlStatus(requestBody: { [key: string]: EtlJobStatus; }, options?: any): AxiosPromise<Array<EtlJob>> {
            return localVarFp.setEtlStatus(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates analytics jobs and returns details along with any errors.
         * @summary Start analytics jobs
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAnalyticsJobs(requestBody: Array<number>, options?: any): AxiosPromise<Array<EtlJobWithError>> {
            return localVarFp.startAnalyticsJobs(requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Retrieves the details of a specific ETL job.
     * @summary Get ETL job details
     * @param {number} job The ETL job key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEtlJob(job: number, options?: any) {
        return DefaultApiFp(this.configuration).getEtlJob(job, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of all ETL jobs.
     * @summary Get all ETL jobs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEtlJobs(options?: any) {
        return DefaultApiFp(this.configuration).getEtlJobs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the organization\'s ETL service type.
     * @summary Get ETL service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEtlService(options?: any) {
        return DefaultApiFp(this.configuration).getEtlService(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the status of a specific ETL job.
     * @summary Get ETL job status
     * @param {number} job The ETL job key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEtlStatus(job: number, options?: any) {
        return DefaultApiFp(this.configuration).getEtlStatus(job, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the statuses of multiple ETL jobs.
     * @summary Set ETL job statuses
     * @param {{ [key: string]: EtlJobStatus; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public setEtlStatus(requestBody: { [key: string]: EtlJobStatus; }, options?: any) {
        return DefaultApiFp(this.configuration).setEtlStatus(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiates analytics jobs and returns details along with any errors.
     * @summary Start analytics jobs
     * @param {Array<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public startAnalyticsJobs(requestBody: Array<number>, options?: any) {
        return DefaultApiFp(this.configuration).startAnalyticsJobs(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
